// Hard coded site ID's of the current easyEcommerce Templates on VCOR
export const ecommerceTemplates = new Set<string>([
  'a446335a483e794c80c13ceffcbb6e0f31ad6267b107f7b697fb32f3db614e61',
  '5e31d527ae9dd1ff85964c0eb57d359122eca5db161da86913347d662bdff56a',
  '90d91cf1fdeefa88795ea0dc3915665a342825ef4ec3ebf202d58f6cfa52078e',
  '45ff990f71f826669add7b1132fc506178154527b6f1c77edc4e49fc70a9e5f1',
  '16b4d5d1396ec3a518aaa59ca0b6f4bbe91c47e7a85a18a3499e2b227c16dda6',
  'a1631c22bc7e50248fab93e6e06856d5db999ad8fb6e642915fb8ef90589e7f7',
  'c364aecc552af9413e19f4fe2ec6c6d0f4c731e64e3334254cbaa3a5893b1bb2',
]);
export const vcor = 'VCOR';
export const WSP_MANAGING_DISTRIBUTED_TEMPLATES_FLAG = 'wsp_managing_distributed_templates';
export const vwct = 'VWCT';
